import MediaQuery from 'react-responsive'

import screenSizes from '@/constants/screen_sizes'

import CartHeading from './CartHeading'
import MobileCartHeader from './MobileCartHeader'

const CartHeader = () => (
  <>
    <MediaQuery minWidth={screenSizes.sm}>
      <CartHeading />
    </MediaQuery>

    <MediaQuery maxWidth={screenSizes.xs_max}>
      <MobileCartHeader />
    </MediaQuery>
  </>
)

export default CartHeader
